import { fmtDate } from "../../extensions/utils";
import { Tag } from "antd";
import { isMobile } from "../../extensions/design";

const clientItemTagHex = (raw) => {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  return s.startsWith("#") ? s : `#${s}`;
};

const ClientItem = ({ item, onClick }) => {
  const getImage = () => {
    return <img className="client-photo" src={item?.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg` : "/images/sample.png"} alt="client"/>
  }

  return<div className="client-item" onClick={onClick}>
    <div className="client-item-photo">{getImage()}</div>
    <div className="client-item-body">
      <div className="client-item-line-bold-double">
        <div className="client-item-clip client-item-name-with-tags">
          <span className="client-item-name">{item.name}</span>
          <span className="client-item-tag-row">
            {(Array.isArray(item.tags) ? item.tags : []).map((t) => {
              const hex = clientItemTagHex(t.color);
              return (
                <Tag
                  key={t.id}
                  className="client-item-tag-chip"
                  style={{
                    height: 14,
                    marginInlineEnd: 4,
                    fontSize: 11,
                    lineHeight: "16px",
                    ...(hex ? { backgroundColor: hex, borderColor: hex, color: "#fff" } : {}),
                  }}
                >
                  {t.value ?? ""}
                </Tag>
              );
            })}
          </span>
        </div>
        <div className="client-item-clip-right">{item.phone}</div>
      </div>
      <div className="client-item-line-triple">
        <div className="client-item-clip">Карта: {item.card}</div>
        <div className="client-item-clip">Д.р: {fmtDate(item.dateBirth)}</div>
        <div className="client-item-clip client-item-debt"> {isMobile ? "" : "Долг:" } {item.dolg}</div>
        {/* <div style={{textAlign: "center"}}>{item.keyName}</div> */}
      </div>
    </div>
  </div>
}

export default ClientItem;